module.exports = __webpack_public_path__ + "static/img/number10.59bd5357.png";